import React, {useEffect, useRef, useState, useCallback} from "react";

import {Form, Formik} from "formik";
import * as Yup from "yup";

import Box from "@mui/material/Box";

import {GoogleAddress} from "./GoogleAddress";
import {getDataBaseAddress, submitStreetZipComment, getDataReviewOrtreetZip} from "../services/rating";
import {admin_role_id, contractor_role_id, issueLabels, jobIssuesOptions, super_admin_role_id} from "../constant";
import {getWealthFactorService, submitRatting} from "../services/rating";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import {useLocation, useNavigate} from "react-router-dom";
import Avatar from "@mui/material/Avatar";
import CustomUserName from "../CustomComponents/CustomUserName";
import {fDate, fTimeAgo} from "../utils/format-time";
import Typography from "@mui/material/Typography";
import {sweetAlerts} from "../utils/sweet-alerts";
import moment from "moment";
import {Divider} from "antd";
import InlineGrammarChecker from "../CustomComponents/InlineGrammarChecker";
import CustomUserProfile from "../CustomComponents/CustomUserProfile";
import {use} from "react";
import {TextFieldForm} from "../CustomComponents/inputs/TextFieldForm";
import {Alert, IconButton, InputAdornment, Stack} from "@mui/material";
import {Login} from "../services/auth";
import CommentInteraction from "./CommentInteraction";

const {extractStreetAddressWithGoogle, extractStreetAddressFallback} = require("../services/geocoding");

function useWindowWidth() {
	const [width, setWidth] = useState(window.innerWidth);

	useEffect(() => {
		const handleResize = () => setWidth(window.innerWidth);

		window.addEventListener("resize", handleResize);
		return () => window.removeEventListener("resize", handleResize);
	}, []);

	return width;
}

const useScrollAnimation = (threshold = 0.1, delay = 0) => {
	const [isVisible, setIsVisible] = useState(false);
	const ref = useRef();
	useEffect(() => {
		const observer = new IntersectionObserver(
			([entry]) => {
				if (entry.isIntersecting) {
					setTimeout(() => setIsVisible(true), delay);
				}
			},
			{threshold},
		);

		if (ref.current) {
			observer.observe(ref.current);
		}

		return () => observer.disconnect();
	}, [threshold, delay]);

	return {ref, isVisible};
};

const CheckJobSiteSection = ({onHistoricAddressClick}) => {
	// Animation Details
	const location = useLocation();

	const addressState = location.state?.address;
	const from = location.state?.from;

	const sectionAnimation = useScrollAnimation(0.1, 0);
	const cardAnimation = useScrollAnimation(0.2, 200);
	const titleAnimation = useScrollAnimation(0.3, 300);

	const searchedAddress = localStorage.getItem("searchedAddress");

	const [role, setRole] = useState(null);
	const [address, setAddress] = useState(addressState || searchedAddress || "");
	const [addressFlag, setAddressFlag] = useState("");

	const [apiFlag, setApiFlag] = useState(false);
	const [showResults, setShowResults] = useState(false);

	const [addressDetails, setAddressDetails] = useState({
		ratings: [],
		comment: [],
		new_reviews_list: [],
		old_reviews_list: [],
		avg_new_rating: 5,
		avg_old_rating: 5,
		new_comments: [],
		old_comments: [],
		address_data: [],
	});

	const getApiAction = async () => {
		setShowResults(false);

		if (address) {
			setAddressDetails({
				ratings: [],
				comment: [],
				new_reviews_list: [],
				old_reviews_list: [],
				job_issues: {},
				issue_summary: {},
				avg_new_rating: null,
				avg_old_rating: null,
				new_comments: [],
				old_comments: [],
				address_data: {},
			});

			const res = await getDataBaseAddress(address?.trim());

			if (res?.data?.status) {
				const data = res?.data?.data[0];

				let ratingsArray = [];
				let commentArray = [];
				res?.data?.data?.map((item) => {
					ratingsArray = [...ratingsArray, ...item?.ratings];
					commentArray = [...commentArray, ...item?.comment];
				});

				const today = new Date();
				const ninetyDaysAgo = new Date();
				ninetyDaysAgo.setDate(today.getDate() - 90);

				const sorted = commentArray.sort((a, b) => new Date(b.comment_date) - new Date(a.comment_date));

				const newReviews = ratingsArray?.filter((item) => new Date(item.job_date) > ninetyDaysAgo);
				const oldReviews = ratingsArray?.filter((item) => new Date(item.job_date) < ninetyDaysAgo);

				const avgNewRating = newReviews?.length > 1 ? (newReviews?.reduce((sum, job) => sum + job.stars, 0) / newReviews?.length).toFixed(1) : 5;
				const oldNewRating = oldReviews?.length > 1 ? (oldReviews?.reduce((sum, job) => sum + job.stars, 0) / oldReviews?.length).toFixed(1) : 5;

				let addressData = {};

				if (data && ratingsArray?.length >= 2) {
					addressData = data;
				}

				// Always fetch comments using getDataReviewOrtreetZip API (same as ReviewsListingPage)
				// Get addresses_id from data response
				const addresses_id = data?.addresses_id || addressData?.addresses_id;
				let transformedComments = [];
				let newComment = [];
				let oldComment = [];

				if (addresses_id) {
					try {
						const commentResponse = await getDataReviewOrtreetZip(addresses_id, address?.trim());
						if (commentResponse && commentResponse.status === true) {
							const commetsData = commentResponse.data.comments;
							transformedComments = commetsData
								? commetsData.map((review, index) => {
										// Format the date
										const jobDate = review.comment_date ? new Date(review.comment_date) : new Date();
										const formattedDate = jobDate.toISOString().split("T")[0]; // YYYY-MM-DD format
										const fullFormattedDate = moment(formattedDate).format("MMM DD, YYYY");
										const likes = review?.likes || [];
										const trueCount = likes.filter((item) => item?.like == true).length;

										return {
											id: review.street_id || index + 1,
											selfLike: review?.selfLike,
											address: address || "Address not specified",
											commentText: review?.description,
											commenter: review.client_name || "",
											role: "",
											date: fullFormattedDate,
											category: "",
											searchType: review.comment_type ? "Zipcode" : "Street",
											avatar: "👷",
											likes: likes,
											likesCount: trueCount,
											selfCreate: review?.selfCreate,
											type: "comment",
											is_historic: review?.is_historic || review?.is_historic == 1 || review?.is_historic != 0 ? true : false,
											user: review?.user,
											job_date: review.comment_date,
											comment_date: review.comment_date,
											street_id: review?.street_id,
											street_comments: review?.street_comments,
											comment_type: review?.comment_type,
										};
									})
								: [];

							// Filter by historic flag (same API as ReviewsListingPage) - only show new comments
							newComment = transformedComments?.filter((item) => !item?.is_historic) || [];
							oldComment = transformedComments?.filter((item) => item?.is_historic) || [];
						}
					} catch (error) {
						console.error("Error fetching comments with getDataReviewOrtreetZip:", error);
						// On error, set empty arrays
						newComment = [];
						oldComment = [];
					}
				}

				// Set address data with comments from getDataReviewOrtreetZip API
				setAddressDetails({
					ratings: ratingsArray || [],
					comment: sorted || [],
					new_reviews_list: newReviews || [],
					old_reviews_list: oldReviews || [],
					job_issues: data?.job_issues,
					issue_summary: data?.issue_summary,
					avg_new_rating: parseFloat(avgNewRating),
					avg_old_rating: parseFloat(oldNewRating),
					new_comments: newComment || [],
					old_comments: oldComment || [],
					address_data: addressData,
				});

				setTimeout(() => {
					const resultsElement = document.getElementById("search-results");
					if (resultsElement) {
						const yOffset = 63;
						const y = resultsElement.getBoundingClientRect().top + window.pageYOffset + yOffset;
						window.scrollTo({top: y, behavior: "smooth"});
					}
				}, 100);
			}
		}
		setShowResults(true);
	};

	useEffect(() => {
		const role = localStorage.getItem("role");
		const searchedAddress = localStorage.getItem("searchedAddress");
		setRole(role);
		setAddress(searchedAddress);
	}, []);

	useEffect(() => {
		getApiAction();
	}, [address, apiFlag]);

	const width = useWindowWidth();

	return (
		<section id="check-job-site" ref={sectionAnimation.ref} className={width > 990 && `check-site-section py-5 section-fade-in mobile-check-site-order visible`}>
			<div className={width > 990 && "container"}>
				<div className="row justify-content-center">
					<div className="col-lg-12 col-xl-10">
						<div ref={cardAnimation.ref} className={`card card-fade-in  visible`}>
							<div className="card-body">
								<div ref={titleAnimation.ref} className={`content-center fade-in-element visible`}>
									<h2 className="mobile-check-site-title-sm">
										Check A Job Site
										{width > 990 && <span className="badge bg-success rounded-pill beta-badge mobile-beta-badge-sm">Beta</span>}
									</h2>
									<p className="lead-text">Enter an address below to see if any service ratings are available.</p>
								</div>

								<div>
									<CheckJobForm
										callBackAction={(value) => {
											setAddress(value?.address);
											setAddressFlag(value?.type);
										}}
										role={role}
										address={address}
										addressDetails={addressDetails}
										setApiFlag={() => setApiFlag(!apiFlag)}
									/>
								</div>
								{showResults && address && (
									<div id="search-results">
										<ResultsForm
											callBackAction={(value) => {
												setAddress(value?.address);
											}}
											role={role}
											address={address}
											addressFlag={addressFlag}
											closeAction={() => setShowResults(false)}
											addressDetails={addressDetails}
											onHistoricAddressClick={onHistoricAddressClick}
											apiFlag={() => setApiFlag(!apiFlag)}
										/>
									</div>
								)}
								{addressDetails?.new_comments?.length > 0 && showResults && <CommentList addressDetails={addressDetails} onRefresh={() => setApiFlag(!apiFlag)} />}
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
	);
};

const CheckJobForm = ({callBackAction, address, setApiFlag}) => {
	const [searchHistory, setSearchHistory] = useState([]);

	const width = useWindowWidth();

	useEffect(() => {
		let searchList = JSON.parse(localStorage.getItem("searchedAddressList")) || [];
		setSearchHistory(searchList);
	}, []);

	const HistoricPush = (address) => {
		const searchValue = address;

		let searchList = JSON.parse(localStorage.getItem("searchedAddressList")) || [];

		localStorage.removeItem("searchedAddress");

		if (searchValue && searchValue.trim()) {
			searchList = searchList.filter((item) => item !== searchValue.trim());

			searchList.unshift(searchValue.trim());

			if (searchList.length > 10 && width > 990) {
				searchList = searchList.slice(0, 10);
			}
			if (searchList.length > 5 && width < 990) {
				searchList = searchList.slice(0, 5);
			}
			setSearchHistory(searchList);
			localStorage.setItem("searchedAddressList", JSON.stringify(searchList));
		}
	};

	return (
		<Formik
			enableReinitialize
			initialValues={{
				address: address || "",
				type: "type",
			}}
			onSubmit={(values) => {
				setApiFlag();
				HistoricPush(values?.address);
				callBackAction(values);
			}}>
			{(props) => {
				const {setFieldValue, handleSubmit, resetForm, dirty, values} = props;
				return (
					<Form noValidate>
						<div className="row g-3 align-items-end">
							<div className="col-md-8">
								<GoogleAddress
									address={values?.address}
									callBackAction={(val) => {
										if (val.value) {
											setFieldValue("address", val.value);
											setFieldValue("type", val.type);
											// handleSubmit();
										}
									}}
								/>
							</div>

							<div className="col-md-4">
								<button className="btn btn-success btn-lg w-100" onClick={handleSubmit}>
									<svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="me-2">
										<path
											d="M21 21L16.514 16.506L21 21ZM19 10.5C19 15.194 15.194 19 10.5 19C5.806 19 2 15.194 2 10.5C2 5.806 5.806 2 10.5 2C15.194 2 19 5.806 19 10.5Z"
											stroke="white"
											strokeWidth="2"
											strokeLi
											necap="round"
											strokeLinejoin="round"
										/>
									</svg>
									Check Address
								</button>
							</div>
						</div>

						<div className="stats-separator" />

						{/* <div className={`text-center mt-4 fade-in-element visible`}>
							<span className="text-examples">Try These Examples : </span>
							<button
								type="button"
								className="text-success text-decoration-none m-1 me-3 "
								onClick={() => {
									setFieldValue("address", "123 Main St");
								}}>
								123 Main St (Excellent)
							</button>
							<button
								className="text-success text-decoration-none m-1 me-3"
								type="button"
								onClick={() => {
									setFieldValue("address", "Test Address");
								}}>
								Test Address (Good)
							</button>
							<button
								type="button"
								className="text-success text-decoration-none"
								onClick={() => {
									setFieldValue("address", "456 Oak Street");
								}}>
								456 Oak Street (Poor)
							</button>
						</div>
						<div className="stats-separator" /> */}

						<div className="mt-4">
							<h4 className="text-lg font-semibold mb-2">Recent Searches : </h4>
							{searchHistory.map((item, index) => (
								<div
									key={index}
									className="justify-between p-1 d-inline-flex cursor-pointer btn-historic-address-corner m-1"
									onClick={() => {
										handleSubmit();
										setFieldValue("address", item);
									}}>
									<span className="text-gray-700 font-medium pe-1">
										<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24">
											<path fill="currentColor" d="M12 11.5A2.5 2.5 0 0 1 9.5 9A2.5 2.5 0 0 1 12 6.5A2.5 2.5 0 0 1 14.5 9a2.5 2.5 0 0 1-2.5 2.5M12 2a7 7 0 0 0-7 7c0 5.25 7 13 7 13s7-7.75 7-13a7 7 0 0 0-7-7" />
										</svg>
										{item}
									</span>
								</div>
							))}
						</div>
					</Form>
				);
			}}
		</Formik>
	);
};

const ResultsForm = ({address, closeAction, role, addressDetails, addressFlag, onHistoricAddressClick, apiFlag}) => {
	const navigate = useNavigate();
	const is_login = localStorage.getItem("is_login");
	const verified = localStorage.getItem("verified") == "false" ? false : true;

	const location = useLocation();

	const addressState = location.state?.address;
	const from = location.state?.from;

	const [isLogin, setIsLogin] = useState(false);
	const [isOpen, setIsOpen] = useState(false);
	const [showReviewForm, setShowReviewForm] = useState(false);
	const [showCommentForm, setShowCommentForm] = useState(false);
	const [commentFormType, setCommentFormType] = useState("street"); // 'street' or 'zipcode'
	const [submitLoading, setSubmitLoading] = useState(false);
	const [commentFormData, setCommentFormData] = useState({});
	const [languageToolErrors, setLanguageToolErrors] = useState([]);
	const [isCheckingLanguage, setIsCheckingLanguage] = useState(false);

	const [addressData, setAddressData] = useState({});
	const languageToolTimeoutRef = useRef(null);
	const [moderationError, setModerationError] = useState(null);

	useEffect(() => {
		if (is_login) {
			setIsLogin(true);
		}
	}, []);

	const handleReviewsClick = () => {
		const token = localStorage.getItem("auth_token");
		const is_login = localStorage.getItem("is_login");

		if (is_login && token) {
			localStorage.setItem("searchedAddress", address);
			localStorage.setItem("reviews_addresses_id", addressDetails?.address_data?.addresses_id);
			navigate("/reviews");
		} else {
			setIsOpen(true);
		}
	};

	const formatReportedIssues = (issuesObj) => {
		if (!issuesObj || typeof issuesObj !== "object") return "";

		const entries = Object.entries(issuesObj);

		return entries
			.map(([key, count]) => {
				const label = issueLabels[key] || key;
				return `${label} (${count})`;
			})
			.join(", ");
	};

	const extractStreetAddress = async (fullAddress) => {
		if (!fullAddress) return "";

		try {
			const googleResult = await extractStreetAddressWithGoogle(fullAddress, "street");

			setAddressData(googleResult?.components || {});

			if (googleResult.success && googleResult.streetAddress) {
				return googleResult;
			}
		} catch (error) {
			return null;
		}
	};

	const extractStreetAddressSync = (fullAddress) => {
		return extractStreetAddressFallback(fullAddress);
	};

	const handleAddReview = () => {
		const token = localStorage.getItem("auth_token");
		const is_login = localStorage.getItem("is_login");
		const verified = localStorage.getItem("verified");
		if (is_login && token) {
			if (!address || !address.trim()) {
				sweetAlerts("error", "Please enter an address first before adding a review");
				return;
			}

			setShowReviewForm(true);
			setShowCommentForm(false);
			setTimeout(() => {
				const reviewFormElement = document.getElementById("review-form");
				if (reviewFormElement) {
					reviewFormElement.scrollIntoView({behavior: "smooth"});
				}
			}, 100);
		} else {
			setIsOpen(true);
		}
	};

	const handleRateStreet = async () => {
		const token = localStorage.getItem("auth_token");
		const is_login = localStorage.getItem("is_login");

		if (is_login && token) {
			if (!address || !address.trim()) {
				sweetAlerts("error", "Please enter an address first before rating the street");
				return;
			}

			setShowReviewForm(false);
			setCommentFormType("street");

			try {
				const streetAddress = await extractStreetAddress(address);
				setCommentFormData((prev) => ({
					...prev,
					commentType: false,
					fullAddress: streetAddress?.components?.fullAddress,
					postalCode: streetAddress?.components?.postalCode,
				}));
				setShowCommentForm(true);

				setTimeout(() => {
					const commentFormElement = document.getElementById("comment-form");
					if (commentFormElement) {
						commentFormElement.scrollIntoView({behavior: "smooth"});
					}
				}, 100);
			} catch (error) {
				const streetAddress = extractStreetAddressSync(address);
				setCommentFormData((prev) => ({
					...prev,
					commentType: true,
					commentAddress: streetAddress,
				}));
				setShowCommentForm(true);
				setTimeout(() => {
					const commentFormElement = document.getElementById("comment-form");
					if (commentFormElement) {
						commentFormElement.scrollIntoView({behavior: "smooth"});
					}
				}, 100);
			}
		} else {
			setIsOpen(true);
		}
	};

	const handleRateZipcode = async () => {
		const token = localStorage.getItem("auth_token");
		const is_login = localStorage.getItem("is_login");
		if (is_login && token) {
			if (!address || !address.trim()) {
				sweetAlerts("error", "Please enter an address first before rating the zipcode");
				return;
			}
			setShowReviewForm(false);
			setCommentFormType("zipcode");
			const streetAddress = await extractStreetAddress(address);

			setCommentFormData((prev) => ({
				postalCode: streetAddress?.components?.postalCode,
				fullAddress: streetAddress?.components?.fullAddress,
			}));
			setShowCommentForm(true);
			setTimeout(() => {
				const commentFormElement = document.getElementById("comment-form");
				if (commentFormElement) {
					commentFormElement.scrollIntoView({behavior: "smooth"});
				}
			}, 100);
		} else {
			setIsOpen(true);
		}
	};

	const calculateDateStatus = (commentDate) => {
		if (!commentDate) return null;

		const jobDate = new Date(commentDate);
		const today = new Date();
		const daysDiff = Math.floor((today - jobDate) / (1000 * 60 * 60 * 24));

		if (daysDiff <= 90) {
			return {type: "fresh", days: daysDiff};
		} else {
			return {type: "historic", days: daysDiff};
		}
	};

	const checkLanguageTool = useCallback((text) => {
		if (!text || text.trim().length < 3) {
			setLanguageToolErrors([]);
			return;
		}

		// Clear previous timeout
		if (languageToolTimeoutRef.current) {
			clearTimeout(languageToolTimeoutRef.current);
		}

		// Debounce the API call
		languageToolTimeoutRef.current = setTimeout(async () => {
			setIsCheckingLanguage(true);
			try {
				const response = await fetch("https://api.languagetool.org/v2/check", {
					method: "POST",
					headers: {
						"Content-Type": "application/x-www-form-urlencoded",
					},
					body: new URLSearchParams({
						text: text,
						language: "en-US",
					}),
				});

				const data = await response.json();
				setIsCheckingLanguage(false);

				if (data && data.matches) {
					setLanguageToolErrors(data.matches);
				} else {
					setLanguageToolErrors([]);
				}
			} catch (error) {
				console.error("LanguageTool error:", error);
				setIsCheckingLanguage(false);
				setLanguageToolErrors([]);
			}
		}, 1000); // 1 second debounce
	}, []);

	useEffect(() => {
		return () => {
			if (languageToolTimeoutRef.current) {
				clearTimeout(languageToolTimeoutRef.current);
			}
		};
	}, []);

	const handleCommentSubmit = async (values) => {
		try {
			setSubmitLoading(true);
			await new Promise((resolve) => setTimeout(resolve, 2000));

			const dateStatus = calculateDateStatus(values.commentDate);

			let status = false;
			if (dateStatus?.type === "historic") {
				status = true;
			}

			const requestBody = {
				description: values.commentText,
				comment_date: values.commentDate,
				comment_type: values.commentType === "street" ? 0 : 1,
				addresses: values.commentAddress,
				is_historic: status,
				full_addresses: address,
				addressFlag: addressFlag,

				route: addressData.route,
				locality: addressData.locality,
				sub_locality: addressData.sublocality,
				postal_code: addressData.postalCode,
			};

			const response = await submitStreetZipComment(requestBody);

			if (response.data && response.status === true) {
				setCommentFormData({
					commentType: false,
					commentAddress: "",
					commentDate: "",
					commentText: "",
				});
				apiFlag();

				setLanguageToolErrors([]);
				setShowCommentForm(false);
				setShowReviewForm(false);
				setSubmitLoading(false);
				const resultsElement = document.getElementById("check-job-site");
				if (resultsElement) {
					const yOffset = -100; // custom offset
					const y = resultsElement.getBoundingClientRect().top + window.pageYOffset + yOffset;
					window.scrollTo({top: y, behavior: "smooth"});
				}
			} else {
				setSubmitLoading(false);

				if (response.data.reasons) {
					setModerationError({
						message: response.message || "Your comment contains restricted content and cannot be published.",
						reasons: response.data.reasons || [],
						policy_tags: response.data.policy_tags || [],
					});
				} else {
					sweetAlerts("error", response.message || "Failed submitting comment");
				}

				return;
			}
			// Show success message with appropriate context
			if (dateStatus?.type === "historic") {
				setSubmitLoading(false);
				sweetAlerts("success", `Comment submitted successfully! This address will be flagged with "Previous History" due to the job date being ${dateStatus.days} days ago.`);
			} else {
				setSubmitLoading(false);
				sweetAlerts("success", `Comment submitted successfully!`);
			}
		} catch (error) {
			sweetAlerts("error", `Error submitting comment. Please try again.`);
		} finally {
		}
	};

	const handleReviewSubmit = async (values) => {
		try {
			setSubmitLoading(true);
			// Simulate API call
			await new Promise((resolve) => setTimeout(resolve, 2000));

			const dateStatus = calculateDateStatus(values.jobDate);
			const requestBody = {
				address: values.address,
				job_issues: values.jobIssues,
				stars: values.jobRating,
				job_date: values.jobDate,
				addressFlag: addressFlag,
				zip_code: "10001",
				city: "New York",
				state: "NY",
				country: "USA",
				route: addressData.route,
				locality: addressData.locality,
				sub_locality: addressData.sublocality,
				postal_code: addressData.postalCode,
			};

			const response = await submitRatting(requestBody);

			apiFlag();

			if (response.status == true) {
				setShowReviewForm(false);
				setSubmitLoading(false);
				const resultsElement = document.getElementById("check-job-site");

				if (resultsElement) {
					const yOffset = -100;
					const y = resultsElement.getBoundingClientRect().top + window.pageYOffset + yOffset;
					window.scrollTo({top: y, behavior: "smooth"});
				}
			} else {
				setSubmitLoading(false);
				sweetAlerts("error", response.message || "Failed submitting rating");
				return;
			}
			// Show success message with appropriate context
			if (dateStatus?.type === "historic") {
				setSubmitLoading(false);
				sweetAlerts("success", `Rating submitted successfully! This address will be flagged with "Previous History" due to the job date being ${dateStatus.days} days ago.`);
			} else {
				setSubmitLoading(false);
				sweetAlerts("success", "Rating submitted successfully!");
			}
		} catch (error) {
			sweetAlerts("error", "Error submitting rating. Please try again.");
		}
	};

	const handleHistoricAddress = () => {
		const token = localStorage.getItem("auth_token");
		const is_login = localStorage.getItem("is_login");
		if (is_login && token) {
			const historicRatings = addressDetails.old_reviews_list;

			const historicAddressData = {
				addressDetails,
				ratings: historicRatings,
				aggregate_rating: addressDetails.avg_old_rating,
				total_ratings: historicRatings.length,
			};

			onHistoricAddressClick(address, historicAddressData, historicRatings);
		} else {
			setIsOpen(true);
		}
	};

	useEffect(() => {
		if (from === "review") {
			handleAddReview();
		} else if (from === "street") {
			handleRateStreet();
		} else if (from === "zipcode") {
			handleRateZipcode();
		}
	}, [from]);
	return (
		<div className="search-results-inline mt-5">
			<div className="results-header">
				<div className="d-flex justify-content-between align-items-center mb-4">
					<h3 className="results-title mobile-results-title-sm"></h3>
					<button className="btn btn-outline-secondary btn-sm" onClick={closeAction}>
						<svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="me-2">
							<path d="M18 6L6 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
							<path d="M6 6L18 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
						</svg>
						Close Results
					</button>
				</div>
			</div>

			<div className="address-info-vertical">
				{addressDetails?.old_reviews_list?.length >= 0 && (
					<div className="address-header">
						<button className="btn btn-historic-address-corner" onClick={handleHistoricAddress}>
							<svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="me-1">
								<path
									d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67z"
									fill="currentColor"
								/>
							</svg>
							Old Reviews ({addressDetails?.old_reviews_list?.length}) | Old comments ({addressDetails?.old_comments?.length})
						</button>
					</div>
				)}

				<div className="address-main-content">
					<div className="address-icon-section">
						<div className="location-icon-vertical">
							<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
								<path
									d="M21 10C21 17 12 23 12 23C12 23 3 17 3 10C3 7.61305 3.94821 5.32387 5.63604 3.63604C7.32387 1.94821 9.61305 1 12 1C14.3869 1 16.6761 1.94821 18.3639 3.63604C20.0518 5.32387 21 7.61305 21 10Z"
									stroke="white"
									strokeWidth="2"
									strokeLinecap="round"
									strokeLinejoin="round"
								/>
								<path
									d="M12 13C13.6569 13 15 11.6569 15 10C15 8.34315 13.6569 7 12 7C10.3431 7 9 8.34315 9 10C9 11.6569 10.3431 13 12 13Z"
									stroke="white"
									strokeWidth="2"
									strokeLinecap="round"
									strokeLinejoin="round"
								/>
							</svg>
						</div>
					</div>

					<div className="address-details-vertical">
						<h4 className="address-title-vertical">{address}</h4>

						<div
							className={`rating-display-vertical cursor-pointer ${addressDetails?.avg_new_rating >= 4 ? "rating-excellent" : addressDetails?.avg_new_rating >= 3 ? "rating-good" : "rating-excellent"}`}
							// className={`rating-display-vertical cursor-pointer ${getRatingClass(ratingAvg)}`}
							// onClick={role === super_admin_role_id || role === admin_role_id || totalRating > 0 ? handleReviewsClick : handleAddReview}>
							onClick={handleReviewsClick}>
							<div className="stars-vertical">
								{[1, 2, 3, 4, 5].map((star) => (
									<span key={star} className={`star-vertical ${star <= addressDetails?.avg_new_rating ? "filled" : ""}`}>
										★
									</span>
								))}
							</div>
							<div className="rating-text-vertical">
								<span className="rating-number-vertical">{addressDetails?.avg_new_rating}</span>
								<span className="review-count-vertical">({addressDetails?.new_reviews_list?.length || 0} Reviews)</span>
							</div>
							<div className="click-hint-simple cursor-pointer" onClick={role === super_admin_role_id || role === admin_role_id ? handleReviewsClick : handleReviewsClick}>
								<small>Click to view all reviews</small>
							</div>
						</div>

						{is_login && (
							<>
								{addressDetails?.ratings?.length == 0 && addressDetails?.ratings?.length <= 0 && (
									<div className="rating-options mb-3">
										<div className="rating-option">
											<span className="option-icon">👤</span>
											<span className="option-text">You could be the first to rate this address. Early contributions help other contractors avoid bad jobs.</span>
										</div>
									</div>
								)}
							</>
						)}

						{addressDetails?.job_issues && Object.keys(addressDetails?.job_issues).length > 0 && (
							<div className="reported-issues">
								<p className="issues-text">
									<strong>Reported issues:</strong> {formatReportedIssues(addressDetails?.job_issues)}
								</p>
							</div>
						)}
					</div>
				</div>

				{/* Add Review Section */}
				{role === super_admin_role_id || role === admin_role_id ? (
					<></>
				) : (
					<>
						{verified && (
							<>
								<div className="add-review-section-inline text-center border-0 p-0 d-none d-lg-block">
									<div className="d-flex flex-column flex-md-row gap-3 justify-content-center">
										<button className="btn btn-success btn-lg" disabled={!verified} onClick={handleAddReview}>
											<span className="me-2">★</span>
											Add Your Review
										</button>
										<button className="btn btn-success btn-lg" disabled={!verified} onClick={handleRateStreet}>
											<span className="me-2">🏘️</span>
											Street Comment
										</button>
										<button className="btn btn-success btn-lg" disabled={!verified} onClick={handleRateZipcode}>
											<span className="me-2">📍</span>
											Zipcode Comment
										</button>
									</div>
								</div>

								<div className="d-flex flex-md-row gap-3 justify-content-center d-xs-block d-lg-none">
									<Button variant="contained" disabled={!verified} onClick={handleAddReview}>
										<span className="me-2">★</span>
										Add Your Review
									</Button>
									<Button variant="contained" disabled={!verified} onClick={handleRateStreet}>
										<span className="me-2">🏘️</span>
										Street Comment
									</Button>
									<Button variant="contained" disabled={verified} onClick={handleRateZipcode}>
										<span className="me-2">📍</span>
										Zipcode Comment
									</Button>
								</div>
							</>
						)}
					</>
				)}
			</div>

			<DialogBox
				open={isOpen}
				handleClose={() => {
					setIsOpen(false);
				}}
			/>

			{showReviewForm && (
				<div id="review-form">
					<div className="submit-rating-container mt-5">
						<div className="form-container">
							<div className="form-step">
								<div className="step-header">
									<h3>Submit Your Review</h3>
									<p>Help other contractors by sharing your experience with this address</p>
								</div>
							</div>
							<Formik
								enableReinitialize
								initialValues={{
									address: address || "",
									jobIssues: [],
									jobRating: "",
									jobDate: new Date().toISOString().split("T")[0], // default to today
								}}
								validationSchema={Yup.object().shape({
									address: Yup.string().required("Job Address is required"),
									jobIssues: Yup.array().min(1, "Select at least one issue"),
									jobRating: Yup.number().required("Job Rating is required").min(1).max(5),
									jobDate: Yup.date().required("Job Date is required"),
								})}
								onSubmit={(values) => {
									handleReviewSubmit(values);
								}}>
								{(props) => {
									const {setFieldValue, handleSubmit, values, isValid, dirty} = props;

									const allRequiredFilled = values.address.trim() !== "" && values.jobRating >= 1 && values.jobDate && isValid;

									return (
										<Form noValidate onSubmit={handleSubmit}>
											{/* Job Address */}
											<div className="form-group">
												<label className="form-label">
													Job Address *<span className="field-hint">Google verified addresses only</span>
												</label>
												<input type="text" className="form-input" placeholder="Enter the job site address..." value={values.address} onChange={(e) => setFieldValue("address", e.target.value)} />
											</div>

											{/* Job Issues */}
											<div className="form-group">
												<label className="form-label">
													What challenges did you face?
													<span className="field-hint">Select all that apply (optional)</span>
												</label>
												<div className="job-issues-grid">
													{jobIssuesOptions
														.sort((a, b) => {
															if (a.label === "Other") return 1;
															if (b.label === "Other") return -1;
															return a.label.length - b.label.length;
														})
														.map((issue) => (
															<label key={issue.id} className="issue-checkbox">
																<input
																	type="checkbox"
																	checked={values.jobIssues?.includes(issue.id)}
																	onChange={() => {
																		const updatedIssues = values.jobIssues.includes(issue.id)
																			? values.jobIssues.filter((id) => id !== issue.id) // remove
																			: [...values.jobIssues, issue.id]; // add
																		setFieldValue("jobIssues", updatedIssues);
																	}}
																/>
																<span className="checkbox-custom"></span>
																<span className="checkbox-label">{issue.label}</span>
															</label>
														))}
												</div>
											</div>

											{/* Job Rating */}
											<div className="form-group">
												<label className="form-label">
													Overall Job Rating *<span className="field-hint">Rate your overall experience (1-5 stars)</span>
												</label>
												<div className="rating-container">
													<div className="star-rating-large">
														{[1, 2, 3, 4, 5].map((star) => (
															<button key={star} type="button" className={`star-btn-large ${star <= values.jobRating ? "filled" : ""}`} onClick={() => setFieldValue("jobRating", star)}>
																★
															</button>
														))}
													</div>
													<div className="rating-text">
														{values.jobRating > 0 && (
															<span className="rating-description">
																{values.jobRating === 1 && "Poor"}
																{values.jobRating === 2 && "Fair"}
																{values.jobRating === 3 && "Good"}
																{values.jobRating === 4 && "Very Good"}
																{values.jobRating === 5 && "Excellent"}
															</span>
														)}
													</div>
												</div>
											</div>

											{/* Job Date */}
											<div className="form-group">
												<label className="form-label">
													Job Date *<span className="field-hint">When did you work at this job site?</span>
												</label>
												<input
													type="date"
													className="form-input"
													value={values.jobDate}
													onClick={(e) => e.target.showPicker && e.target.showPicker()}
													onChange={(e) => setFieldValue("jobDate", e.target.value)}
													max={new Date().toISOString().split("T")[0]}
												/>
											</div>

											{/* Submit Button */}

											<div className="form-navigation d-flex justify-content-center">
												<button
													type="submit"
													className="btn btn-success btn-lg"
													disabled={!allRequiredFilled || submitLoading}
													style={{
														opacity: !allRequiredFilled || submitLoading ? 0.6 : 1,
														cursor: !allRequiredFilled || submitLoading ? "not-allowed" : "pointer",
													}}>
													{submitLoading ? "Submitting..." : "Submit Review"}
												</button>
											</div>
										</Form>
									);
								}}
							</Formik>
						</div>
					</div>
				</div>
			)}

			{showCommentForm && (
				<div id="comment-form" className="submit-rating-container mt-5">
					<div className="form-container">
						<div className="form-step">
							<div className="step-header">
								<h3>Submit Your Comment</h3>
								<p>Help other contractors by sharing your experience with this Street or Zip code.</p>
							</div>

							<Formik
								enableReinitialize
								initialValues={{
									commentType: commentFormType || "street",
									commentAddress: commentFormType === "street" ? commentFormData?.fullAddress : commentFormData?.postalCode || "",
									commentText: "",
									commentDate: new Date().toISOString().split("T")[0],
								}}
								validationSchema={Yup.object().shape({
									commentAddress: Yup.string().required("Address or Zipcode is required"),
									commentDate: Yup.date().required("Comment Date is required"),
									commentText: Yup.string().required("Comment Text is required").max(1000, "Comment cannot exceed 1000 characters"),
								})}
								onSubmit={(values) => {
									handleCommentSubmit(values);
								}}>
								{({values, setFieldValue, handleSubmit, touched, errors, isValid, dirty}) => {
									const allRequiredFilled = values.commentAddress !== "" && values.commentDate && values.commentText !== "" && isValid;
									return (
										<Form noValidate onSubmit={handleSubmit}>
											<div className="form-group">
												<label className="form-label">Search Type</label>
												<div className="search-type-toggle">
													<button
														type="button"
														className={`toggle-btn ${values.commentType === "street" ? "active" : ""}`}
														onClick={() => {
															setFieldValue("commentType", "street");
															setFieldValue("commentAddress", commentFormData?.fullAddress);
														}}>
														Street
													</button>
													<button
														type="button"
														className={`toggle-btn ${values.commentType === "zipcode" ? "active" : ""}`}
														onClick={() => {
															setFieldValue("commentType", "zipcode");
															setFieldValue("commentAddress", commentFormData?.postalCode);
														}}>
														Zipcode
													</button>
												</div>
											</div>

											<div className="form-group">
												<label className="form-label">
													{values.commentType === "street" ? "Street Address" : "Zipcode"} *<span className="field-hint">Google verified addresses only</span>
												</label>
												<input
													type="text"
													className="form-input"
													placeholder={values.commentType === "street" ? "Enter street address..." : "Enter zipcode..."}
													value={values.commentAddress}
													onChange={(e) => setFieldValue("commentAddress", e.target.value)}
												/>
												{touched.commentAddress && errors.commentAddress && <div className="error-message">{errors.commentAddress}</div>}
											</div>

											<div className="form-group">
												<label className="form-label">
													Comment Date *<span className="field-hint">When did you work at this job site?</span>
												</label>
												<input
													type="date"
													className="form-input"
													value={values.commentDate}
													onClick={(e) => e.target.showPicker && e.target.showPicker()}
													onChange={(e) => setFieldValue("commentDate", e.target.value)}
													max={new Date().toISOString().split("T")[0]}
												/>
												{touched.commentDate && errors.commentDate && <div className="error-message">{errors.commentDate}</div>}
											</div>

											<div className="form-group">
												<label className="form-label">
													Comment Text *<span className="field-hint">Describe your experience with this job site</span>
												</label>
												{/* Moderation Error Display - Show at top of text field */}
												{moderationError && (
													<div
														className="moderation-error-alert"
														style={{
															backgroundColor: "#fee",
															border: "1px solid #fcc",
															borderRadius: "4px",
															padding: "12px",
															marginBottom: "10px",
															color: "#c33",
														}}>
														<strong style={{display: "block", marginBottom: "8px"}}>{moderationError.message}</strong>
														{moderationError.reasons && moderationError.reasons.length > 0 && (
															<div style={{fontSize: "14px", marginTop: "8px"}}>
																<strong>Reasons:</strong>
																<ul style={{margin: "4px 0 0 20px", padding: 0}}>
																	{moderationError.reasons.map((reason, idx) => (
																		<li key={idx}>{reason}</li>
																	))}
																</ul>
															</div>
														)}
														{moderationError.policy_tags && moderationError.policy_tags.length > 0 && (
															<div style={{fontSize: "12px", marginTop: "8px", color: "#999"}}>Tags: {moderationError.policy_tags.join(", ")}</div>
														)}
													</div>
												)}
												<textarea
													name="commentText"
													className={`form-textarea ${moderationError ? "error" : ""}`}
													value={values.commentText}
													onChange={(e) => {
														setFieldValue("commentText", e.target.value);
														checkLanguageTool(e.target.value);
														// Clear moderation error when user starts typing
														if (moderationError) {
															setModerationError(null);
														}
													}}
													placeholder="Describe your experience with this job/street/zipcode. Be specific about what went well and what could have been better…"
													rows="6"
													maxLength="1000"
												/>
												<div className="character-count">{values.commentText.length}/1000 characters</div>
												{touched.commentText && errors.commentText && <div className="error-message">{errors.commentText}</div>}
											</div>

											<div className="form-navigation d-flex justify-content-center">
												<button
													type="submit"
													className="btn btn-success btn-lg"
													disabled={!allRequiredFilled || submitLoading}
													style={{
														opacity: !allRequiredFilled || submitLoading ? 0.6 : 1,
														cursor: !allRequiredFilled || submitLoading ? "not-allowed" : "pointer",
													}}>
													{submitLoading ? "Submitting..." : "Submit Comment"}
												</button>
											</div>
										</Form>
									);
								}}
							</Formik>
						</div>
					</div>
				</div>
			)}
		</div>
	);
};

const CommentList = ({addressDetails, onRefresh}) => {
	const token = localStorage.getItem("auth_token");
	const is_login = localStorage.getItem("is_login");

	// Sort comments by date (newest first - last comment on top)
	const sortedComments = addressDetails?.new_comments
		? [...addressDetails.new_comments].sort((a, b) => {
				// Sort by date (newest first - last comment on top)
				const aDate = new Date(a?.comment_date || a?.job_date || 0);
				const bDate = new Date(b?.comment_date || b?.job_date || 0);
				return bDate.getTime() - aDate.getTime();
			})
		: [];

	return (
		<div className="search-results-inline mt-5 mobile-comment-list-wrapper">
			<div className="row">
				{sortedComments.length > 0 &&
					sortedComments.map((item, key) => {
						return (
							<div key={item.id} className="col-12 mb-3">
								<div className={`bg-white rating-card mobile-comment-card ${item?.selfCreate === 1 ? "border-success border-2" : "border-0"} shadow-sm ${item?.selfCreate === 1 ? "bg-light" : ""}`}>
									{item?.selfCreate === 1 && (
										<div className="card-header bg-success text-white py-2">
											<div className="d-flex align-items-center">
												<svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" className="me-2">
													<path d="M20 2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h14l4 4V4c0-1.1-.9-2-2-2zm-2 12H6v-2h12v2zm0-3H6V9h12v2zm0-3H6V6h12v2z" />
												</svg>
												<span className="fw-semibold">Your Comment</span>
											</div>
										</div>
									)}
									{(item?.is_historic || item?.is_historic == 1) && (
										<div className="card-header bg-secondary text-white py-2">
											<div className="d-flex align-items-center">
												<svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" className="me-2">
													<path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
												</svg>
												<span className="fw-semibold">Old Review</span>
											</div>
										</div>
									)}
									<div className="card-body py-3 mobile-comment-card-body">
										<div className="row g-0">
											<Box sx={{display: "flex", justifyContent: "space-between", mb: 2}} className="mobile-comment-header">
												<Box sx={{display: "flex", alignItems: "center", gap: 1}}>
													{/* <Avatar className="mobile-comment-avatar"></Avatar> */}
													<CustomUserProfile user={item?.user} sx={{fontWeight: 900}} />
													<Box sx={{}}>
														<span className="text-blue text-capitalize mobile-comment-username">
															<CustomUserName user={item?.user} sx={{fontWeight: 900}} />
														</span>
														<div className="text-body-secondary mobile-comment-time">
															<Typography variant="body2" sx={{fontSize: 12, fontWeight: 600}}>
																{fTimeAgo(item?.comment_date)}
															</Typography>
														</div>
													</Box>
												</Box>

												<Box>
													<div className="d-flex align-items-center">
														{/* <div className={`search-type-badge ${item?.comment_type ? "street-badge" : "zipcode-badge"}`}>
															<span className="search-type-icon me-2">{item?.comment_type ? "🏘️" : "📍"}</span>
															<span className="search-type-text">{item?.comment_type ? "Street" : "Zipcode"}</span>
														</div> */}

														<div className={`search-type-badge mobile-comment-badge ${item?.comment_type ? "zipcode-badge" : "street-badge"}`}>
															<span className="search-type-icon me-2">{item?.comment_type ? "📍" : "🏘️"}</span>
															<span className="search-type-text">{item?.comment_type ? "Zipcode" : "Street"}</span>
														</div>
													</div>
												</Box>
											</Box>

											<div className="row g-0 align-items-center mobile-comment-content-row">
												<div className="col-md-8 mobile-comment-description-col">
													<Typography variant="body2" sx={{fontSize: 20, mb: 2, px: 1}} className="mobile-comment-description">
														{item?.commentText}
													</Typography>
												</div>
												<div className="col-md-4 mobile-comment-date-col">
													<div className="text-end mobile-comment-date-wrapper">
														<div className="text-muted small mb-1">Commented on</div>
														<div className="fw-semibold text-dark">{fDate(item?.comment_date)}</div>
													</div>
												</div>
											</div>

											<Divider className="mobile-comment-divider" />

											{/* Like and Reply Section */}
											<Box sx={{px: 2, py: 1}}>
												<CommentInteraction item={item} onRefresh={onRefresh} variant="mobile" />
											</Box>

											<Box sx={{pl: 5}} className="mobile-comment-replies">
												{item?.street_comments &&
													item?.street_comments?.length > 0 &&
													[...item.street_comments]
														.sort((a, b) => {
															// Sort sub-comments by date (newest first)
															const aDate = new Date(a?.createdAt || a?.comment_date || 0);
															const bDate = new Date(b?.createdAt || b?.comment_date || 0);
															return bDate.getTime() - aDate.getTime();
														})
														.map((comment) => {
															return (
																<div className="attachment-item d-flex mb-2 mobile-comment-reply-item" style={{cursor: "default"}}>
																	<Box sx={{mb: 1}}>
																		<span className="text-blue text-capitalize mobile-comment-reply-username">
																			<Box sx={{display: "flex", alignItems: "center", gap: 1}}>
																				<CustomUserProfile user={comment?.user} width={32} sx={{fontSize: 13}} />
																				<CustomUserName user={comment?.user} sx={{fontWeight: 900, fontSize: 14}} />
																			</Box>
																			{/* <CustomUserName user={comment?.user} sx={{fontWeight: 900}} /> */}
																		</span>
																		<div className="text-body-secondary mobile-comment-reply-text">{comment?.description}</div>
																	</Box>
																	<Typography variant="body2" sx={{fontSize: 12, fontWeight: 600}} className="mobile-comment-reply-time">
																		{fTimeAgo(comment?.createdAt)}
																	</Typography>
																</div>
															);
														})}
											</Box>
										</div>
									</div>
								</div>
							</div>
						);
					})}
			</div>
		</div>
	);
};

const DialogBox = ({open, handleClose}) => {
	const navigate = useNavigate();
	const [successMsg, setSuccessMsg] = useState(null);
	const [errorMsg, setErrorMsg] = useState(null);
	const [showPassword, setShowPassword] = useState(true);
	const [isLoading, setIsLoading] = useState(false);

	const handleLogin = async (values) => {
		try {
			const response = await Login({email: values.email, password: values.password});
			if (response.status === true && response.data) {
				try {
					const RoleString = response.data.role === "super-admin" ? super_admin_role_id : response.data.role === "admin" ? admin_role_id : contractor_role_id;

					localStorage.setItem("auth_token", response.data.token);
					localStorage.setItem("is_login", true);
					localStorage.setItem("first_name", response.data.first_name);
					localStorage.setItem("last_name", response.data.last_name);
					localStorage.setItem("profile_image", response.data.profile_image);
					localStorage.setItem("role", RoleString);
					localStorage.setItem("verified", response.data.verified);
					localStorage.setItem("trusted", response.data.trusted);
					localStorage.setItem("badge", response.data.badge || false);

					handleClose();
					setSuccessMsg("Login successful! Redirecting...");
				} catch (error) {
					setErrorMsg(error?.message || "Login failed. Please try again.");
				}
			}
			if (response.status !== true) {
				if (response?.data?.need_to === "verified_mail") {
					window.location.href = `/verify-email?uuid=${response?.data?.user_uuid}`;
				}

				setErrorMsg(response.message || "Login failed. Please try again.");
			}
		} catch (error) {
			setErrorMsg(error?.message || "Login failed. Please try again.");
		}
	};

	const handleClickShowPassword = () => setShowPassword((show) => !show);

	const handleMouseDownPassword = (event) => {
		event.preventDefault();
	};

	return (
		<Dialog onClose={handleClose} open={open}>
			<DialogTitle></DialogTitle>
			<DialogContent>
				<DialogContentText>
					<Alert severity="info">Only contractors can view, edit, and write reviews. Please log in as a contractor to continue. Others can see average ratings, issues, and comments.</Alert>
				</DialogContentText>

				<Formik
					enableReinitialize
					initialValues={{
						email: "",
						password: "",
					}}
					validationSchema={Yup.object({
						email: Yup.string().email("Enter valid email").required("Email is required"),
						password: Yup.string().min(6, "Password must be at least 6 characters").required("Password is required"),
					})}
					onSubmit={async (values, {setSubmitting}) => {
						await handleLogin(values);
						setSubmitting(false);
					}}>
					{(props) => {
						const {handleSubmit} = props;
						return (
							<Form noValidate onSubmit={handleSubmit}>
								<Stack spacing={2} mt={5}>
									<h2 className="form-title">Sign in</h2>
									<p className="form-subtitle">Please login to continue to your account.</p>

									{successMsg && <Alert severity="success">{successMsg}</Alert>}
									{errorMsg && <Alert severity="error">{errorMsg}</Alert>}

									<TextFieldForm formik={props} label="Email" field="email" placeholder="Enter your email " />
									<TextFieldForm
										formik={props}
										label="Password"
										field="password"
										placeholder="Enter your password "
										type={showPassword ? "password" : "text"}
										InputProps={{
											endAdornment: (
												<InputAdornment position="end">
													<IconButton aria-label="toggle password visibility" onClick={handleClickShowPassword} onMouseDown={handleMouseDownPassword} edge="end" disabled={isLoading}>
														<svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
															{showPassword ? (
																<path
																	d="M17.94 17.94A10.07 10.07 0 0 1 12 20C7 20 2.73 16.39 1 12A18.45 18.45 0 0 1 5.06 5.06M9.9 4.24A9.12 9.12 0 0 1 12 4C17 4 21.27 7.61 23 12A18.5 18.5 0 0 1 19.42 16.42M14.12 14.12A3 3 0 1 1 9.88 9.88M1 1L23 23"
																	stroke="currentColor"
																	strokeWidth="2"
																	strokeLinecap="round"
																	strokeLinejoin="round"
																/>
															) : (
																<path d="M1 12S5 4 12 4S23 12 23 12S19 20 12 20S1 12 1 12Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
															)}
														</svg>
													</IconButton>
												</InputAdornment>
											),
										}}
									/>

									<div className="form-options">
										<div className="form-check"></div>
										<button
											type="button"
											className="forgot-password-link"
											onClick={() => {
												navigate("/login?tab=forgot_password");
												handleClose();
											}}>
											Forgot password?
										</button>
									</div>
									<Stack direction="row" spacing={2}>
										<Button fullWidth variant="contained" type="submit" sx={{py: 1}} onClick={handleSubmit}>
											Login
										</Button>
										<Button onClick={handleClose} variant="outlined" color="dark">
											Close
										</Button>
									</Stack>
								</Stack>
							</Form>
						);
					}}
				</Formik>

				<div className="form-footer">
					<p>
						Need an account?{" "}
						<button
							className="link-btn"
							onClick={() => {
								navigate("/login?tab=signup");
								handleClose();
							}}>
							Create one
						</button>
					</p>
				</div>
			</DialogContent>
		</Dialog>
	);
};
export default CheckJobSiteSection;
